import { useState, useEffect } from 'react'
import { getSubscriptionById } from '../api/subscriptions'

export function useSubscriptionById(id) {
  const [subscription, setSubscription] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    if (!id) {
      setLoading(false)
      return
    }
    setLoading(true)
    getSubscriptionById(id)
      .then((data) => {
        if (!cancelled) setSubscription(data)
      })
      .catch((err) => {
        if (!cancelled) setError(err.message)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [id])

  return { subscription, loading, error }
}
